import React, { useState, useEffect, useContext } from 'react';
import { Collapse, Table, Tooltip, InputNumber } from 'antd';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CompositeView,
  CrudContext,
  useRouter,
  GridView,
  Icon,
  MasterDetailForm,
  Widget,
  FormatText,
  FormNumber,
  FormInput,
  FormDatePicker,
  usePromise,
  FormSubmitButton,
  Button,
  FormItem,
} from '@digital/ui';
import { getAllProjetosFiltroContextoPlanilhaCapex } from '@app/api/projeto';
import UploadFile from '@app/components/uploadFile';
import { exportaPlanilhaRfaAnoMes, exportaModelo } from '@app/api/exportaFile';
import { createPlanilhaOrcamentoRfa } from '@app/api/projeto';
import { OrcamentoPlanilha } from '@app/api/ordemInvestimento';
import { exportaPlanilhaRfaAntiga } from '@app/api/exportaFile';
import { GetAllPlanilhaRfaAntigas } from '@app/api/ordemInvestimento';
import { hasPermission } from '@app/helpers/permissions';
import PlanilhaRfaTabela from './PlanilhaRfaTabela';
import TablePlanilha from '../TablePlanilhas';

const PlanilhaRfa = () => {
  const { Panel } = Collapse;
  const [projetos, setProjetos] = useState(() => getAllProjetosFiltroContextoPlanilhaCapex);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [mostarBotaoExportar, setMostarBotaoExportar] = useState<boolean>();
  //const validationSchema = Yup.object().shape({});
  const [planilhas, setPlanilhas] = useState<OrcamentoPlanilha[]>();
  const [projetoSelecionado, setProjetoSelectionado] = useState<OrcamentoPlanilha[]>();

  useEffect(() => {
    const getProjetoData = async () => {
      const result = await getAllProjetosFiltroContextoPlanilhaCapex();
      if (result) setProjetos(result);
    };

    getProjetoData();
  }, []);

  useEffect(() => {
    const getPlanilhasData = async (id: string) => {
      const result = await GetAllPlanilhaRfaAntigas(id);
      if (result) setPlanilhas(result);
    };

    if (projetoSelecionado) getPlanilhasData(projetoSelecionado.id);
  }, [projetoSelecionado]);

  const handleCreatePlanilhaOrcamento = (values: any, selectedItem: any) => {
    createPlanilhaOrcamentoRfa(selectedItem.id, values.formData, values).then(result => {
      if (result.valid) {
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setProjetos(() => Promise.resolve(undefined));
        setProjetos(() => getAllProjetosFiltroContextoPlanilhaCapex);
      }
    });
  };

  const hasPlanilhaRfa = (planilha: boolean) => {
    if (planilha) {
      setMostarBotaoExportar(true);
    } else {
      setMostarBotaoExportar(false);
    }
  };

  const exportarPlanilha = (item: OrcamentoPlanilha) => {
    if (item) {
      exportaPlanilhaRfaAntiga(item.projetoId, item.nome, item.numero, item.revisao, item.dataAprovacao);
    }
  };

  const exportarModelo = (modelo: string) => {
    if (modelo) {
      exportaModelo(modelo);
    }
  };

  const validationSchema = Yup.object().shape({
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO RFA DO PROJETO ${x.numero}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.statusNome || ''}>
      <CompositeView>
        {hasPermission(['Dono', 'ORCADO_ECONOMICO_RFA_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              setProjetoSelectionado(selectedItem);
              return (
                <GridView noform>
                  {hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) && (
                    <MasterDetailForm
                      validationSchema={validationSchema}
                      onSubmit={values => {
                        handleCreatePlanilhaOrcamento(values, selectedItem);
                      }}>
                      <Widget
                        title="Importação de planilha"
                        actions={[
                          selectedItem && selectedItem.possuiPlanilhaCapex === true && (
                            <Button
                              type="link"
                              icon="files-xls"
                              onClick={() => {
                                exportaPlanilhaRfaAnoMes(selectedItem.id, 'planilhaRfa.xlsx');
                              }}>
                              Exportar Planilha
                            </Button>
                          ),
                          <Button
                            type="link"
                            icon="files-xls"
                            onClick={() => {
                              exportarModelo('modeloOrcadoRfa');
                            }}>
                            Modelo de importação RFA
                        </Button>,
                          hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) && (
                            <FormSubmitButton type="primary">
                              <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                          ),
                        ]}>
                        <FormInput label="Nº RFA" name="numero_planilha" span={4} />
                        <FormInput label="Revisão" name="texto_revisao" span={4} />
                        <FormDatePicker
                          label="Data de Aprovação"
                          name="dataAprovacao"
                          format="DD/MM/YYYY"
                          span={4}
                          required
                        />
                        {selectedItem && hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) ? (
                          <UploadFile
                            hasFile={hasFile}
                            accept={'.xlsx'}
                            label="Incluir planilha"
                            id="importFilePlanilha"
                            selectedItem={selectedItem}
                          />
                        ) : (
                            <> </>
                          )}
                      </Widget>
                    </MasterDetailForm>
                  )}
                  {selectedItem ? (
                    <PlanilhaRfaTabela
                      atualizarTelaProp={atualizarTela}
                      projeto={selectedItem}
                      hasPlanilha={hasPlanilhaRfa}
                    />
                  ) : (
                      <> </>
                    )}
                  {selectedItem &&
                    hasPermission(['ORCADO_ECONOMICO_RFA_VISUALIZAR_MENU']) &&
                    (planilhas && planilhas.length > 0) ? (
                      <TablePlanilha dataPlanilhas={planilhas || []} exportarPlanilhaAntiga={exportarPlanilha} />
                    ) : (
                      <> </>
                    )}
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default PlanilhaRfa;
